import _defineProperty2 from "/Users/danthila/Documents/Million Spaces/MS/ms-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/danthila/Documents/Million Spaces/MS/ms-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/danthila/Documents/Million Spaces/MS/ms-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/danthila/Documents/Million Spaces/MS/ms-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/danthila/Documents/Million Spaces/MS/ms-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/danthila/Documents/Million Spaces/MS/ms-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
var _shape;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { element, string, bool, number, array, object, func, oneOfType, oneOf, shape } from 'prop-types';
import { Table, Spin, Pagination } from 'antd';
import throttle from 'lodash.throttle';
var noop = function noop() {};
var fetchDebounce = function () {
  var loading = [];
  return function (_ref) {
    var page = _ref.page,
      pageSize = _ref.pageSize,
      onFetch = _ref.onFetch;
    var now = Date.now();
    if (!loading[page] || loading[page] && now - loading[page] > 1000) {
      onFetch({
        page: page,
        pageSize: pageSize
      });
    }
    loading[page] = now;
  };
}();
function getCachePage(_ref2) {
  var step = _ref2.step,
    maxPage = _ref2.maxPage,
    pageSize = _ref2.pageSize,
    onFetch = _ref2.onFetch,
    loading = _ref2.loading,
    cacheData = _ref2.cacheData,
    currentPage = _ref2.currentPage;
  var pageBefore = currentPage - step;
  var pageAfter = currentPage + step;
  var cachePageDataBefore = cacheData[pageBefore];
  var cachePageData = cacheData[currentPage];
  var cachePageDataAfter = cacheData[pageAfter];
  if (!loading) {
    !cachePageData && currentPage > 0 && currentPage <= maxPage && fetchDebounce({
      page: currentPage,
      pageSize: pageSize,
      onFetch: onFetch
    });
    !cachePageDataBefore && pageBefore > 0 && pageBefore <= maxPage && fetchDebounce({
      page: pageBefore,
      pageSize: pageSize,
      onFetch: onFetch
    });
    !cachePageDataAfter && pageAfter > 0 && pageAfter <= maxPage && fetchDebounce({
      page: pageAfter,
      pageSize: pageSize,
      onFetch: onFetch
    });
  }
  var lastOwnDataPage = currentPage;
  if (cachePageDataAfter) {
    lastOwnDataPage = pageAfter;
  } else if (cachePageData) {
    lastOwnDataPage = currentPage;
  } else if (cachePageDataBefore) {
    lastOwnDataPage = pageBefore;
  }
  return [cachePageDataBefore || [], cachePageData || [], cachePageDataAfter || [], lastOwnDataPage];
}
var computeState = function computeState(_ref3, _ref4) {
  var pageSize = _ref3.pageSize,
    onFetch = _ref3.onFetch,
    loading = _ref3.loading,
    total = _ref3.total,
    cachePages = _ref3.bidirectionalCachePages,
    _ref3$dataSource = _slicedToArray(_ref3.dataSource, 2),
    page = _ref3$dataSource[0],
    data = _ref3$dataSource[1];
  var maxPage = _ref4.maxPage,
    currentPage = _ref4.currentPage,
    cacheData = _ref4.cacheData,
    rowHeight = _ref4.rowHeight;
  var bidirectionalCachePages = cachePages;
  var newCacheData = cacheData;
  if (cachePages < 1) {
    bidirectionalCachePages = 1;
  }
  if (bidirectionalCachePages * 2 + 1 < maxPage) {
    var startPage = currentPage - bidirectionalCachePages;
    startPage = startPage < 1 ? 1 : startPage;
    var endPage = currentPage + bidirectionalCachePages;
    endPage = endPage > maxPage ? maxPage : endPage;
    cacheData[page] = data; // eslint-disable-line

    newCacheData = Array.from({
      length: maxPage
    });
    Array.prototype.splice.apply(newCacheData, [startPage, endPage - startPage + 1].concat(cacheData.slice(startPage, endPage + 1)));
  }
  newCacheData[page] = data;
  var _getCachePage = getCachePage({
      step: 1,
      maxPage: maxPage,
      pageSize: pageSize,
      onFetch: onFetch,
      loading: loading,
      cacheData: newCacheData,
      currentPage: currentPage
    }),
    _getCachePage2 = _slicedToArray(_getCachePage, 4),
    cachePageDataBefore = _getCachePage2[0],
    cachePageData = _getCachePage2[1],
    cachePageDataAfter = _getCachePage2[2],
    lastOwnDataPage = _getCachePage2[3];
  var upperHeight = Math.round((currentPage - 1 - (cachePageDataBefore.length ? 1 : 0)) * pageSize * rowHeight);
  var underHeight = Math.round(
  // 已经是最后一页，直接返回0，否则如果有零头total % pageSize，需要加上不满一个page的零头lastOwnDataPageLength，但需要少加一个整页pageSize
  maxPage === lastOwnDataPage ? 0 : ((maxPage - lastOwnDataPage) * pageSize + total % pageSize) * rowHeight);
  var dataSource = cachePageDataBefore.concat(cachePageData).concat(cachePageDataAfter);
  return {
    hasCacheBefore: !!cachePageDataBefore.length,
    hasCache: !!cachePageData.length,
    hasCacheAfter: !!cachePageDataAfter.length,
    cacheData: newCacheData,
    dataSource: dataSource,
    underHeight: underHeight,
    upperHeight: upperHeight
  };
};
/* eslint-disable react/no-redundant-should-component-update */
var InfinityTable = /*#__PURE__*/function (_Component) {
  _inherits(InfinityTable, _Component);
  var _super = _createSuper(InfinityTable);
  function InfinityTable() {
    var _this2;
    _classCallCheck(this, InfinityTable);
    var _this;
    _this = _this2 = _super.apply(this, arguments);
    _defineProperty(_assertThisInitialized(_this2), "state", {
      scrollTop: 0,
      // 滚动条位置
      dataSource: [],
      // DOM上显示的数据
      rowHeight: 0,
      // 每行的实际高度
      cacheData: [],
      // 缓存的数据集大小
      currentPage: 1,
      // 当前页位置
      underHeight: 0,
      // 下撑高
      upperHeight: 0 // 上撑高
    });

    _defineProperty(_assertThisInitialized(_this2), "isInitial", true);
    _defineProperty(_assertThisInitialized(_this2), "isReady", false);
    _defineProperty(_assertThisInitialized(_this2), "isPageBoundary", false);
    _defineProperty(_assertThisInitialized(_this2), "isPaginationClick", false);
    _defineProperty(_assertThisInitialized(_this2), "refUpperPlaceholder", null);
    _defineProperty(_assertThisInitialized(_this2), "refUnderPlaceholder", null);
    _defineProperty(_assertThisInitialized(_this2), "refLoadingPlaceholder", null);
    _defineProperty(_assertThisInitialized(_this2), "refScroll", null);
    _defineProperty(_assertThisInitialized(_this2), "refTable", null);
    _defineProperty(_assertThisInitialized(_this2), "refFooter", null);
    _defineProperty(_assertThisInitialized(_this2), "refPageBoundaryBefore", null);
    _defineProperty(_assertThisInitialized(_this2), "refPageBoundaryAfter", null);
    _defineProperty(_assertThisInitialized(_this2), "ioTargetState", {
      refUnderPlaceholder: null,
      refUpperPlaceholder: null,
      refTable: null,
      refPageBoundaryBefore: null,
      refPageBoundaryAfter: null
    });
    _defineProperty(_assertThisInitialized(_this2), "scrollToPage", function () {
      var _this$props$paginatio;
      var pageSize = _this.props.pageSize;
      var rowHeight = _this.state.rowHeight;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var page = args[0];
      _this.refScroll.scrollTop = (page - 1) * pageSize * rowHeight + 1; // Bug fix: + 1个像素,点击页码向后翻页时存在少一个像素就变成上一页的bug

      _this.isPaginationClick = true;
      _this.props.pagination && _this.props.pagination.onChange && (_this$props$paginatio = _this.props.pagination).onChange.apply(_this$props$paginatio, args);
    });
    _defineProperty(_assertThisInitialized(_this2), "updateTable", function () {
      var tableHeight = _this2.refTable.clientHeight;
      var scrollTop = _this2.refScroll.scrollTop;
      var _this$state = _this2.state,
        rowHeight = _this$state.rowHeight,
        maxPage = _this$state.maxPage;
      var _this$props = _this2.props,
        pageSize = _this$props.pageSize,
        total = _this$props.total,
        debug = _this$props.debug;
      if (_this2.isInitial) {
        // 还在初始状态
        maxPage = Math.ceil(total / pageSize);
        var length = _this2.state.dataSource.length;
        rowHeight = tableHeight / length;
        if (rowHeight) {
          // 当行高出现，表示初次呈现数据数时
          _this2.isInitial = false;
          _this2.initialReslove();
        }
      }
      var currentPage = Math.floor(scrollTop / (pageSize * rowHeight)) + 1 || 1;
      currentPage = currentPage > maxPage ? maxPage : currentPage;
      debug && console.log('updateTable', {
        currentPage: currentPage
      });
      _this2.setState({
        direction: _this2.refScroll.scrollTop - _this2.state.scrollTop < 0 ? 'up' : 'down',
        scrollTop: _this2.refScroll.scrollTop,
        maxPage: maxPage,
        currentPage: currentPage,
        rowHeight: rowHeight
      } // () => console.log('computeState done', this.state),
      );
    });
    return _this2;
  }
  _createClass(InfinityTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      /* eslint-disable */
      this.refRoot = ReactDOM.findDOMNode(this);
      this.refScroll = this.refRoot.getElementsByClassName('ant-table-body')[0];
      this.refTable = this.refScroll.getElementsByTagName('tbody')[0];
      /* eslint-enabled */

      this.createUnderPlaceholder();
      this.createUpperPlaceholder();
      this.setStateWithThrottle = throttle(this.updateTable, 0);
      this.props.onScroll && this.refScroll.addEventListener('scroll', this.props.onScroll);
      if (this.refScroll) {
        this.io = new IntersectionObserver(function (changes) {
          var debug = _this3.props.debug;
          var shouldUpdate = true;
          _this3.ioTargetState = changes.reduce(function (result, change) {
            var ret = _objectSpread({}, result);
            switch (change.target) {
              case _this3.refPageBoundaryBefore:
                ret.refPageBoundaryBefore = change; // Bug fix:
                // 向下滚动的时候，如果边界第一行数据触发，不需要更新视图，因为上一页的最后一行已经触发了视图更新,
                // 但是用户通过点击分页切换，而不是滚动的情况例外，因为此时需要更新页码

                if (!_this3.isPaginationClick && changes.length === 1 && _this3.state.direction === 'down') {
                  shouldUpdate = false;
                }
                break;
              case _this3.refPageBoundaryAfter:
                ret.refPageBoundaryAfter = change; // Bug fix:
                // 向上滚动的时候，如果边界最后行数据触发，不需要更新视图，因为上一页的第一行已经触发了视图更新
                // 但是用户通过点击分页切换，而不是滚动的情况例外，因为此时需要更新页码

                if (!_this3.isPaginationClick && changes.length === 1 && _this3.state.direction === 'up') {
                  shouldUpdate = false;
                }
                break;
              default: // console.log(change)
            }

            return ret;
          }, _this3.ioTargetState);
          _this3.isPaginationClick = false;
          debug && console.log('shouldUpdate:IntersectionObserver', {
            shouldUpdate: shouldUpdate,
            changes: changes
          });
          shouldUpdate && _this3.setStateWithThrottle();
        }, {
          root: this.refScroll,
          threshold: [0, 1]
        });
        this.toggleObserver();
      }
      this.props.onFetch({
        page: 1,
        pageSize: this.props.pageSize
      });
      new Promise(function (reslove) {
        _this3.initialReslove = reslove;
      }).then(function () {
        var _this$props2 = _this3.props,
          pageSize = _this$props2.pageSize,
          _this$props2$paginati = _this$props2.pagination.defaultCurrent,
          defaultCurrent = _this$props2$paginati === void 0 ? 1 : _this$props2$paginati;
        _this3.createLoadingPlaceholder(); // fullLoading

        _this3.scrollToPage(defaultCurrent);
        var visibleRowCount = Math.round(_this3.refScroll.clientHeight / _this3.state.rowHeight);
        _this3.isReady = true;
        if (pageSize < visibleRowCount) {
          console.warn("pagesize(".concat(pageSize, ") less than visible row count(").concat(visibleRowCount, "), maybe you set error!"));
        }
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var pageSize = nextProps.pageSize,
        debug = nextProps.debug;
      var maxPage = nextState.maxPage,
        currentPage = nextState.currentPage,
        dataSource = nextState.dataSource,
        direction = nextState.direction,
        rowHeight = nextState.rowHeight;
      var shouldUpdate = true; // 有且仅有当前页上下边界同时触发时，表示更换边界，不需要更新

      if (this.isPageBoundary) {
        shouldUpdate = false;
        this.isPageBoundary = false;
      }
      debug && console.log('shouldUpdate:updateBoundary', {
        shouldUpdate: shouldUpdate
      });
      if (shouldUpdate && !this.isInitial) {
        var currentPageReal = currentPage; // 由于state中的currentPage延迟与真实的currentPage不一致，当出现这种情况时，强制updateTable()

        currentPageReal = Math.floor(this.refScroll.scrollTop / (pageSize * rowHeight)) + 1 || 1;
        currentPageReal = currentPageReal > maxPage ? maxPage : currentPageReal;
        if (currentPageReal !== currentPage) {
          this.updateTable();
          shouldUpdate = false;
        }
        debug && console.log('shouldUpdate:currentPageReal', {
          currentPageReal: currentPageReal,
          currentPage: currentPage,
          shouldUpdate: shouldUpdate
        });
      }
      if (shouldUpdate) {
        var _this$ioTargetState = this.ioTargetState,
          refPageBoundaryBefore = _this$ioTargetState.refPageBoundaryBefore,
          refPageBoundaryAfter = _this$ioTargetState.refPageBoundaryAfter;
        switch (direction) {
          case 'up':
            if (this.state.hasCacheAfter && currentPage < maxPage - 2 &&
            // Bug fix: 如果是最后三页向后点击切换，需要刷新视图，否则页码表记停留在前一页
            refPageBoundaryBefore && refPageBoundaryBefore.intersectionRatio > 0) shouldUpdate = false;
            break;
          case 'down':
            if (this.state.currentPage === currentPage && this.state.hasCacheAfter &&
            // Bug fix: 可能存在3页数据已经加载到了, 但之前没有刷新的情况，所以需要刷新，判断特征是之前的数据小于3页
            refPageBoundaryAfter && refPageBoundaryAfter.intersectionRatio > 0) shouldUpdate = false;
        }
        debug && console.log('shouldUpdate:verboseBoundary', {
          shouldUpdate: shouldUpdate,
          direction: direction,
          dataSource: dataSource,
          Before: refPageBoundaryBefore && refPageBoundaryBefore.intersectionRatio,
          After: refPageBoundaryAfter && refPageBoundaryAfter.intersectionRatio
        });
      } // if (shouldUpdate) {
      //   shouldUpdate = [1, maxPage, maxPage - 1, maxPage - 2].includes(currentPage)
      //     ? dataSource.length > 0
      //     : [
      //         // 如果已经加载3页数据，需要更新视图，否则不在 fullLoading 状态，即使数据不满3页也需要更新视图
      //         // 兼容部份项目，每页，可能多一个条目的情况，如一系列数据，有个合计行
      //         ...(this.fullLoading ? [] : [0, pageSize, pageSize + 1, pageSize * 2, pageSize * 2 + 1, pageSize * 2 + 2]),
      //         pageSize * 3,
      //         pageSize * 3 + 1,
      //         pageSize * 3 + 2,
      //         pageSize * 3 + 3,
      //       ].includes(dataSource.length)
      //   debug &&
      //     console.log('shouldUpdate:3Page', {
      //       currentPage,
      //       dataSource,
      //       shouldUpdate,
      //       state: this.state,
      //       nextState,
      //     })
      // }

      return shouldUpdate;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(preProps, preState) {
      var _this$state2 = this.state,
        hasCache = _this$state2.hasCache,
        hasCacheBefore = _this$state2.hasCacheBefore,
        currentPage = _this$state2.currentPage,
        dataSource = _this$state2.dataSource,
        maxPage = _this$state2.maxPage;
      var _this$props3 = this.props,
        pageSize = _this$props3.pageSize,
        debug = _this$props3.debug;
      if (!this.isInitial) {
        var before, after;
        if (hasCache && hasCacheBefore) {
          if (currentPage === 1 || currentPage === maxPage - 1) {
            before = 0;
            after = pageSize - 1;
          } else if (currentPage === maxPage) {
            before = 0;
            after = dataSource.length - 1;
          } else {
            before = pageSize;
            after = pageSize * 2 - 1;
          }
          if (this.refPageBoundaryBefore !== this.refTable.children[before]) {
            this.refPageBoundaryBefore && this.io.unobserve(this.refPageBoundaryBefore);
            this.refPageBoundaryAfter && this.io.unobserve(this.refPageBoundaryAfter);
            this.refPageBoundaryBefore = this.refTable.children[before];
            this.refPageBoundaryAfter = this.refTable.children[after];
            this.refPageBoundaryAfter && this.io.observe(this.refPageBoundaryAfter);
            this.refPageBoundaryBefore && this.io.observe(this.refPageBoundaryBefore);
            debug && this.refPageBoundaryBefore && console.log('componentDidUpdate', this.refPageBoundaryBefore.innerText);
            debug && this.refPageBoundaryAfter && console.log('componentDidUpdate', this.refPageBoundaryAfter.innerText);
            this.isPageBoundary = true;
          }
        }
        var emptyPlaceholder = this.refRoot.querySelector('.ant-table-placeholder');
        emptyPlaceholder && (emptyPlaceholder.style.display = 'none');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.onScroll && this.refScroll.removeEventListener('scroll', this.props.onScroll);
      this.io.disconnect();
    }
  }, {
    key: "createLoadingPlaceholder",
    value: function createLoadingPlaceholder() {
      var refLoadingPlaceholder = document.createElement('div');
      refLoadingPlaceholder.setAttribute('id', 'refLoadingPlaceholder');
      var clientRect = this.refScroll.getBoundingClientRect();
      refLoadingPlaceholder.setAttribute('style', "position:fixed; width:".concat(clientRect.width, "px; height:").concat(clientRect.height, "px"));
      this.refScroll.insertBefore(refLoadingPlaceholder, this.refScroll.firstChild);
      this.refLoadingPlaceholder = refLoadingPlaceholder;
    } // 创建底部填充块
  }, {
    key: "createUnderPlaceholder",
    value: function createUnderPlaceholder() {
      var refUnderPlaceholder = document.createElement('div');
      refUnderPlaceholder.setAttribute('id', 'refUnderPlaceholder');
      this.refScroll.appendChild(refUnderPlaceholder);
      this.refUnderPlaceholder = refUnderPlaceholder;
    } // 创建顶部填充块
  }, {
    key: "createUpperPlaceholder",
    value: function createUpperPlaceholder() {
      var refUpperPlaceholder = document.createElement('div');
      refUpperPlaceholder.setAttribute('id', 'refUpperPlaceholder');
      this.refScroll.insertBefore(refUpperPlaceholder, this.refScroll.firstChild);
      this.refUpperPlaceholder = refUpperPlaceholder;
    }
  }, {
    key: "toggleObserver",
    value: function toggleObserver() {
      var condition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (condition) {
        this.io.observe(this.refUpperPlaceholder);
        this.io.observe(this.refUnderPlaceholder);
        this.io.observe(this.refTable);
        this.refPageBoundaryBefore && this.io.observe(this.refPageBoundaryBefore);
        this.refPageBoundaryAfter && this.io.observe(this.refPageBoundaryAfter);
      } else {
        this.io.unobserve(this.refUpperPlaceholder);
        this.io.unobserve(this.refUnderPlaceholder);
        this.io.unobserve(this.refTable);
        this.refPageBoundaryBefore && this.io.unobserve(this.refPageBoundaryBefore);
        this.refPageBoundaryAfter && this.io.unobserve(this.refPageBoundaryAfter);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        pageSize = _this$props4.pageSize,
        loadingIndicator = _this$props4.loadingIndicator,
        loading = _this$props4.loading,
        total = _this$props4.total,
        columns = _this$props4.columns,
        debug = _this$props4.debug,
        forwardedRef = _this$props4.forwardedRef,
        pagination = _this$props4.pagination,
        rest = _objectWithoutProperties(_this$props4, ["pageSize", "loadingIndicator", "loading", "total", "columns", "debug", "forwardedRef", "pagination"]);
      var _this$state3 = this.state,
        dataSource = _this$state3.dataSource,
        upperHeight = _this$state3.upperHeight,
        underHeight = _this$state3.underHeight,
        cacheData = _this$state3.cacheData,
        currentPage = _this$state3.currentPage;
      this.fullLoading = !cacheData[currentPage];
      var fullLoading = this.fullLoading;
      debug && console.log('%c Rendering', 'color:#f00;font-weight:bold');
      return React.createElement(Fragment, null, React.createElement(InfinityTable.LoadingPlaceHolder, {
        domNode: this.refLoadingPlaceholder,
        loading: fullLoading,
        loadingIndicator: React.createElement(Spin, {
          tip: "Loading..."
        })
      }), React.createElement(InfinityTable.PlaceHolder, {
        height: upperHeight,
        domNode: this.refUpperPlaceholder,
        loading: loading && !fullLoading,
        loadingIndicator: loadingIndicator
      }), React.createElement(InfinityTable.PlaceHolder, {
        height: underHeight,
        domNode: this.refUnderPlaceholder,
        loading: loading && !fullLoading,
        loadingIndicator: loadingIndicator
      }), total && pagination && ['top', 'both'].includes(pagination.position) && React.createElement(Pagination, _extends({
        showQuickJumper: true
      }, pagination, {
        onChange: this.scrollToPage,
        current: currentPage,
        pageSize: pageSize,
        showSizeChanger: false,
        total: total,
        className: "infinity-page-table-pagination ".concat(pagination && pagination.className ? pagination.className : '')
      })), React.createElement(Table, _extends({
        rowKey: function rowKey(record) {
          return record.key;
        }
      }, rest, {
        ref: forwardedRef,
        columns: columns,
        dataSource: dataSource,
        pagination: false,
        className: "infinity-page-table ".concat(rest.className ? rest.className : '')
      })), total && pagination && [undefined, 'bottom', 'both'].includes(pagination.position) && React.createElement(Pagination, _extends({
        showQuickJumper: true
      }, pagination, {
        onChange: this.scrollToPage,
        current: currentPage,
        pageSize: pageSize,
        showSizeChanger: false,
        total: total,
        className: "infinity-page-table-pagination ".concat(pagination && pagination.className ? pagination.className : '')
      })));
    }
  }], [{
    key: "PlaceHolder",
    value: function PlaceHolder(_ref5) {
      var height = _ref5.height,
        domNode = _ref5.domNode,
        loading = _ref5.loading,
        loadingIndicator = _ref5.loadingIndicator;
      return domNode && ReactDOM.createPortal(React.createElement("div", {
        style: {
          height: "".concat(height, "px")
        }
      }, loading && loadingIndicator, " "), domNode);
    }
  }, {
    key: "LoadingPlaceHolder",
    value: function LoadingPlaceHolder(_ref6) {
      var domNode = _ref6.domNode,
        loading = _ref6.loading,
        loadingIndicator = _ref6.loadingIndicator;
      return domNode && ReactDOM.createPortal(loading ? loadingIndicator : React.createElement("div", null), domNode);
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, prevState) {
      return computeState(props, prevState);
    }
  }]);
  return InfinityTable;
}(Component);
InfinityTable.defaultProps = {
  // loading 效果， A visual react component for Loading status
  loadingIndicator: React.createElement("div", {
    style: {
      textAlign: 'center',
      paddingTop: 20,
      paddingBottom: 20,
      border: '1px solid #e8e8e8'
    }
  }, React.createElement(Spin, {
    tip: "Loading..."
  })),
  pagination: {
    defaultCurrent: 1
  },
  // 分页器
  onScroll: null,
  // 滚动事件
  onFetch: noop,
  // 滚动到低部触发Fetch方法
  bidirectionalCachePages: Infinity,
  // 当前页前后的缓存页码数量，默认为无限
  total: 0,
  // 总共数据条数
  debug: false,
  // display console log for debug
  loading: false,
  // 是否loading状态
  pageSize: 30 // 每次Loading数据量，pageSize * 3 = 最大真实DOM大小，Reality DOM row count
};

InfinityTable.propTypes = {
  // loading 效果
  className: string,
  loadingIndicator: element,
  onScroll: func,
  // 滚动事件
  pagination: oneOfType([bool, shape((_shape = {
    className: string,
    position: oneOf(['both', 'top', 'bottom'])
  }, _defineProperty2(_shape, "className", string), _defineProperty2(_shape, "defaultCurrent", number), _defineProperty2(_shape, "hideOnSinglePage", bool), _defineProperty2(_shape, "itemRender", func), _defineProperty2(_shape, "showQuickJumper", bool), _defineProperty2(_shape, "showTotal", func), _defineProperty2(_shape, "simple", bool), _defineProperty2(_shape, "size", string), _defineProperty2(_shape, "onChange", func), _shape))]),
  onFetch: func.isRequired,
  // 滚动触发Fetch方法
  pageSize: number.isRequired,
  bidirectionalCachePages: number.isRequired,
  total: number.isRequired,
  dataSource: array.isRequired,
  columns: array.isRequired,
  forwardedRef: object,
  debug: bool,
  loading: bool.isRequired
};
export default React.forwardRef(function (props, ref) {
  return React.createElement(InfinityTable, _extends({}, props, {
    forwardedRef: ref
  }));
});
export { InfinityTable };